import http from './httpService';
import config from './config.json';

export const getPublicToken = () => {
    return http.get(`${config.oauthapi}/api/oauth/token`);
};
